<div
  class="row-auto justify-start align-items-center text-center"
  style="height: 100px"
>
  <ng-content select="siat-card-item"></ng-content>
</div>
